import React from 'react';
import phoneNumber from '../assets/image/phone_number.svg';

const Footer = props => (
  <div className="Footer" >
    <div className="FooterText" >
      電話での<br/>お問い合わせ
    </div>
    <div className="FooterText" >
      9:00~18:00
    </div>
    <img className="FooterLogo" src={phoneNumber} alt="phoneNumber" />
  </div>
);

export default Footer;
